import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from '@mui/material';
import { useEffect, useState } from 'react';
import DeviceSelection from '../../Device/DeviceSelection';
import InvestigationDeviceMap from './InvestigationDeviceMap';
import { getItems } from '../../../data/Wideawake/wideawakeDataFns';
const debug = process.env.REACT_APP_DEBUG && false;
function DeviceInvestigation(props) {
    const [openDevices, setOpenDevices] = useState(false);
    const [selectedDevices, setSelectedDevices] = useState([]);
    const [gateways, setGateways] = useState([]);
    const [rerender, setRerender] = useState(0);
    useEffect(() => {
        const getGateways = async () => {
            const res = await getItems({ objectTypeId: 'Gateway' });
            if (res.data?.Items) {
                setGateways(res.data.Items);
            }
        };
        getGateways();
    }, []);
    useEffect(() => {
        setRerender(rerender + 1);
    }, [selectedDevices]);
    return (_jsxs("div", { children: [_jsx(Button, { variant: 'outlined', color: 'primary', size: 'small', onClick: () => setOpenDevices(true), children: selectedDevices.length > 0 ? `Devices (${selectedDevices.length})` : 'Select Devices' }), selectedDevices && _jsx(InvestigationDeviceMap, { devices: selectedDevices, gateways: gateways }, rerender), _jsx(DeviceSelection, { visible: openDevices, close: () => setOpenDevices(false), setSelectedDevices: setSelectedDevices })] }));
}
export default DeviceInvestigation;
